import { createFlagMenuPrimaryClick, enableSurfaceFlagTemplates } from '@gonfalon/dogfood-flags/dogfood-flags';

/**
 * Which "Create flag" control the event came from.
 *
 * `primary` is the single button whose primary click opens the template menu. `split` is
 * everything else — the split button whose chevron opens it, and the plain button on accounts
 * where templates aren't surfaced at all, which behaves the same way as far as reaching the menu
 * from the primary click goes.
 */
export type CreateFlagMenuVariant = 'split' | 'primary';

/**
 * Whether the primary-click menu is the control on screen. The one definition of that condition:
 * the components branch on it to decide what to render and this module labels events from it, so
 * a change to the gating can't leave the funnel reporting an arm nobody saw.
 */
export function hasPrimaryClickMenu(): boolean {
  return enableSurfaceFlagTemplates() && createFlagMenuPrimaryClick();
}

/**
 * Read once per event rather than passed down from the components, so that no call site can
 * report a step without its arm, and so both arms are guaranteed to label themselves the same
 * way.
 *
 * This is deliberately separate from the `exp_*` experiment property the analytics registry
 * attaches, which records the *assignment*: that only appears when the flag served through an
 * experiment allocation, so on its own it can't tell you which UI a person actually saw. This
 * records the control that was on screen.
 */
export function createFlagMenuVariant(): CreateFlagMenuVariant {
  return hasPrimaryClickMenu() ? 'primary' : 'split';
}
